export function isAdmin() {
    const token = localStorage.getItem("access_tocken");
    if (!token) return false;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const roles = payload.realm_access?.roles || [];
        return roles.some(r => r.toUpperCase() === 'ADMIN');
    } catch {
        return false;
    }
}
